
export class ActivityModel{
    id?: number;
    titleAr?:string;
    titleEn?:string;
    descriptionAr?:string;
    descriptionEn?:string;
    imageURl?:string;
    fileURL?:string;
    activityTypeId?:number;
    date?:Date|null;
 
    inHome?:boolean;

    constructor(item?:ActivityModel){
        item = item? item:{};
        this.id = item.id? item.id:0;
        this.titleAr = item.titleAr? item.titleAr:'';
        this.titleEn = item.titleEn? item.titleEn:'';
        this.descriptionAr = item.descriptionAr? item.descriptionAr:'';
        this.descriptionEn = item.descriptionEn? item.descriptionEn:'';
        this.imageURl = item.imageURl? item.imageURl:'';
        this.fileURL = item.fileURL? item.fileURL:'';
        this.activityTypeId = item.activityTypeId? item.activityTypeId:0;
        this.date = item.date? item.date:null;
        this.inHome = item.inHome? item.inHome:null;
       

    }

}